import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, doc, deleteDoc, updateDoc, addDoc } from "firebase/firestore";
import Papa from "papaparse";

const ProductManagement = () => {
  const [products, setProducts] = useState([]);
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [quantity, setQuantity] = useState("");
  const [Category, setCategory] = useState("");
  const [imageBase64, setImageBase64] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    const querySnapshot = await getDocs(collection(db, "products"));
    setProducts(querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => setImageBase64(reader.result);
  };

  const handleAddOrUpdate = async (e) => {
    e.preventDefault();

    if (editingId) {
      const productRef = doc(db, "products", editingId);
      await updateDoc(productRef, {
        name,
        price: Number(price),
        stock: Number(stock),
        quantity: String(quantity),
        Category,
        image: imageBase64,
      });
      setEditingId(null);
    } else {
      await addDoc(collection(db, "products"), {
        name,
        price: Number(price),
        stock: Number(stock),
        quantity: String(quantity),
        Category,
        image: imageBase64,
      });
    }

    setName("");
    setPrice("");
    setStock("");
    setQuantity("");
    setCategory("");
    setImageBase64("");
    fetchProducts();
  };

  const handleEdit = (product) => {
    setEditingId(product.id);
    setName(product.name);
    setPrice(product.price);
    setStock(product.stock);
    setQuantity(product.quantity);
    setCategory(product.Category || "");
    setImageBase64(product.image || "");
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "products", id));
    fetchProducts();
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (result) => {
        for (const row of result.data) {
          await addDoc(collection(db, "products"), {
            name: row.name,
            price: Number(row.price),
            stock: Number(row.stock),
            quantity: String(row.quantity),
            Category: row.Category || "Uncategorized",
            image: row.image || "",
          });
        }
        fetchProducts();
      },
    });
  };

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ textAlign: "center", color: "#333" }}>{editingId ? "Edit Product" : "Add Product"}</h2>

      <form onSubmit={handleAddOrUpdate} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Product Name"
          required
          style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <input
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          placeholder="Price"
          required
          type="number"
          style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <input
          value={stock}
          onChange={(e) => setStock(e.target.value)}
          placeholder="Stock"
          required
          type="number"
          style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <input
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          placeholder="Quantity"
          required
          type="text"
          style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <input
          value={Category}
          onChange={(e) => setCategory(e.target.value)}
          placeholder="Category"
          required
          type="text"
          style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}
        />
        <input type="file" accept="image/*" onChange={handleImageChange} style={{ padding: "8px" }} />
        <button
          style={{
            padding: "10px",
            backgroundColor: editingId ? "#28a745" : "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          {editingId ? "Update Product" : "Add Product"}
        </button>
      </form>

      <h3 style={{ marginTop: "20px" }}>Upload Products via CSV</h3>
      <input type="file" accept=".csv" onChange={handleFileUpload} style={{ padding: "8px" }} />

      <h3 style={{ marginTop: "20px" }}>Product List</h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: "15px" }}>
        {products.length === 0 ? (
          <p style={{ textAlign: "center", color: "#777" }}>No products found!</p>
        ) : (
          products.map((product) => (
            <div
              key={product.id}
              style={{
                border: "1px solid #ddd",
                borderRadius: "5px",
                padding: "15px",
                boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                textAlign: "center",
              }}
            >
              {product.image && (
                <img
                  src={product.image}
                  alt={product.name}
                  style={{ width: "100%", height: "150px", objectFit: "cover", borderRadius: "5px" }}
                />
              )}
              <div>
                <h4 style={{ margin: "10px 0", color: "#333" }}>{product.name}</h4>
                <p style={{ color: "#555" }}>Price: ₹{product.price}</p>
                <p style={{ color: "#555" }}>Stock: {product.stock}</p>
                <p style={{ color: "#555" }}>Quantity: {product.quantity}</p>
                <p style={{ color: "#555", fontWeight: "bold" }}>Category: {product.Category}</p>
              </div>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
                <button
                  onClick={() => handleEdit(product)}
                  style={{ padding: "8px", backgroundColor: "#ffc107", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(product.id)}
                  style={{ padding: "8px", backgroundColor: "#dc3545", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}
                >
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ProductManagement;
